import React from 'react';
import PropTypes from 'prop-types';

import { Loading } from 'uikit/loaders';

import VersioningComposeTitle from './versioningComposeTitle';
import VersioningComposeDescription from './versioningComposeDescription';

import styles from '../styles/versioningCompose.module.scss';

const TYPE_MAP = {
  title: VersioningComposeTitle,
  description: VersioningComposeDescription,
};

const VersioningCompose = ({
  isLoading = false,
  model = {},
  schema = {},
}) => {

  if (isLoading) return <Loading className={styles.loader} />;

  const mappedSchemaFields = Object.entries(schema).map(([key, { CustomComponent, type }]) => {
    const Component = CustomComponent || TYPE_MAP[type];

    if (!Component) {
      console.warn('Component type has not been found. Please update the TYPE_MAP.'); 
      return;
    }

    const value = model[key];

    return (
      <Component key={key} value={value} />
    );
  });

  return (
    <div className={styles.element}>
      {mappedSchemaFields}
    </div>
  );
}

VersioningCompose.propTypes = {
  isLoading: PropTypes.bool,
  model: PropTypes.shape({}),
  schema: PropTypes.shape({}),
};

export default React.memo(VersioningCompose);
